import {AbstractControl} from '@angular/forms';

export class LoginAttributes {
  username: string;
  password: string;
}

export class NewLoginAttributes {
  UserName: string;
  Password: string;
}

export class ChangePassword {
  UserName: string;
  Password: string;
  MailSentFlag: string;
}

export class ConfirmPasswordValidator {
  static MatchPassword(control: AbstractControl) {
    let password = control.get('password').value;
    let confirmPassword = control.get('confirmPassword').value;
    if (password != confirmPassword) {
      control.get('confirmPassword').setErrors({ ConfirmPassword: true });

      // control.get('confirmPassword').valid;
      console.log('nt eq', control)
      // return null;
    }
    else {
      control.get('confirmPassword').setErrors({ ConfirmPassword: false });
      // control.valid;
      console.log('eq', control)

      // control.get('confirmPassword').setErrors({ ConfirmPassword: true });
      // control.get('confirmPassword').invalid

      // return null;
    }
  }
}
